import { render, staticRenderFns } from "./athleteWheel.vue?vue&type=template&id=42f126c8&scoped=true"
import script from "./athleteWheel.vue?vue&type=script&lang=js"
export * from "./athleteWheel.vue?vue&type=script&lang=js"
import style0 from "./athleteWheel.vue?vue&type=style&index=0&id=42f126c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f126c8",
  null
  
)

export default component.exports